import { Box, FormControl, InputLabel, MenuItem, Select, SelectChangeEvent } from '@mui/material';
import { useMemo } from 'react';

import { Spinner } from '@/components/common/Spinner';
import { SelectOptionProps } from '@/models/SelectOption';
import { ApplicationStatus } from '@/utils/constants';

type Props = {
  value: ApplicationStatus | null;
  options: SelectOptionProps[];
  loading: boolean;
  onChange: (status: ApplicationStatus | null) => void;
};

export default function StatusSelectField({ value, options, loading, onChange }: Props) {
  const fieldDisabled = useMemo(() => {
    return options.length === 0 || loading;
  }, [options, loading]);

  return (
    <FormControl fullWidth>
      <InputLabel id='application-status-label'>Application Status</InputLabel>
      <Select
        labelId='application-status-label'
        label='Application Status'
        MenuProps={{ PaperProps: { sx: { maxHeight: 300, maxWidth: 460 } } }}
        disabled={fieldDisabled}
        value={value !== null ? value.toString() : ''}
        onChange={(e: SelectChangeEvent) =>
          onChange(e.target.value !== '' ? Number(e.target.value) : null)
        }
        endAdornment={
          fieldDisabled ? (
            <Box marginRight={2}>
              <Spinner type='circular' size={18} />
            </Box>
          ) : undefined
        }
      >
        {options.map((s) => (
          <MenuItem key={s.value} value={s.value}>
            {s.label}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
}
